import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { PaginationHeader } from '../../PaginationHeader.js';
import { getPagingInfo, Pagination } from '../../Pagination.js';
import { getPageSize } from '../../../utils/pageSize.js';
import { Page } from '../../Page/component.js';
import { CreateButton } from '../create-button/component.js';
var _excluded = ["activePage", "children", "createButtonDataProps", "data", "fullPage", "isLoadingData", "loadData", "maxButtons", "noRecordsMessage", "onPageChange", "pageSize", "postContent", "preContent", "resultsDisplayed", "totalCount", "useCoreTable"];

var PagedView = function PagedView(_ref) {
  var activePage = _ref.activePage,
      children = _ref.children,
      createButtonDataProps = _ref.createButtonDataProps,
      data = _ref.data,
      _ref$fullPage = _ref.fullPage,
      fullPage = _ref$fullPage === void 0 ? true : _ref$fullPage,
      isLoadingData = _ref.isLoadingData,
      _ref$loadData = _ref.loadData,
      loadData = _ref$loadData === void 0 ? function () {} : _ref$loadData,
      maxButtons = _ref.maxButtons,
      noRecordsMessage = _ref.noRecordsMessage,
      onPageChange = _ref.onPageChange,
      pageSize = _ref.pageSize,
      postContent = _ref.postContent,
      preContent = _ref.preContent,
      _ref$resultsDisplayed = _ref.resultsDisplayed,
      resultsDisplayed = _ref$resultsDisplayed === void 0 ? true : _ref$resultsDisplayed,
      totalCount = _ref.totalCount,
      useCoreTable = _ref.useCoreTable,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(activePage || 1),
      _useState2 = _slicedToArray(_useState, 2),
      activePageState = _useState2[0],
      setActivePageState = _useState2[1];

  useEffect(function () {
    loadData();
  }, []);
  useEffect(function () {
    if (activePage !== undefined && activePage !== activePageState) {
      setActivePageState(activePage);
    }
  }, [activePage]);

  var changePageSize = function changePageSize(newPageSize) {
    getPageSize(newPageSize);
    onPageChange && onPageChange(1);
  };

  var onPageChangeHandler = function onPageChangeHandler(pageNumber) {
    onPageChange && onPageChange(pageNumber);
    setActivePageState(pageNumber);
    window.scrollTo(0, 0);
  };

  var renderCard = function renderCard(child, className) {
    if (!child) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "card-".concat(className)
    }, child), /*#__PURE__*/React.createElement("div", {
      className: "clearfix"
    }));
  };

  var wrapContent = function wrapContent(children) {
    if (fullPage) {
      return /*#__PURE__*/React.createElement(Page, _extends({}, rest, {
        pageType: "parent",
        actionButton: /*#__PURE__*/React.createElement(CreateButton, _extends({}, rest, createButtonDataProps))
      }), children);
    } else {
      return children;
    }
  };

  var renderBodyContent = function renderBodyContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "clearfix"
    }), renderCard(preContent, 'pre'), renderPagingContent(), renderCard(postContent, 'post'));
  };

  var renderPagingContent = function renderPagingContent() {
    var pagingInfo = getPagingInfo({
      data: data,
      pageSize: pageSize,
      totalCount: totalCount,
      activePage: activePageState
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderPaginationHeader(pagingInfo), renderContent(), renderPagination(pagingInfo));
  };

  var renderPaginationHeader = function renderPaginationHeader(pagingInfo) {
    return /*#__PURE__*/React.createElement(PaginationHeader, {
      activePage: activePageState,
      hasPagination: pagingInfo.hasPagination,
      showPageSizeDropdown: !pageSize,
      pSize: pagingInfo.pageSize,
      changePageSize: changePageSize,
      dataSize: pagingInfo.dataSize,
      resultsDisplayed: resultsDisplayed,
      totalCount: pagingInfo.totalCount
    });
  };

  var renderPagination = function renderPagination(pagingInfo) {
    if (!pagingInfo || !pagingInfo.hasPagination || useCoreTable) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Pagination, {
      data: data,
      activePage: activePageState,
      maxButtons: maxButtons,
      pageSize: pageSize,
      totalCount: totalCount,
      onPageChange: onPageChangeHandler
    });
  };

  var renderNoContent = function renderNoContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "page-panel"
    }, noRecordsMessage);
  };

  var renderContent = function renderContent() {
    return children;
  };

  var content = noRecordsMessage && !isLoadingData && (data === undefined || !data.length) ? renderNoContent() : renderBodyContent();
  return /*#__PURE__*/React.createElement(React.Fragment, null, wrapContent(content));
};

export { PagedView };